export default {"src":"/_next/static/media/seekintro-logo.df09cf31.svg","height":47,"width":243,"blurWidth":0,"blurHeight":0};